<template>
  <div class="user-verifications-control_uvc" :class="{ [curTheme]: true }">

    <button
      v-if="isOrgAdmin || isSysAdmin"
      @click="openWin"
      class="uvc_btn lite-button sm-button">Верификации</button>

    <el-dialog
      title="Верификации пользователя"
      class="uvc_win"
      :visible.sync="winOn">

      <div class="uvc_cells">
        <template v-if="verifs.win.length > 0 && (isSysAdmin || isOrgAdmin)">
          <div
            v-for="(org, i) in verifs.win"
            :key="`org-verif-${i}`"
            class="uvc_cell">
            <el-checkbox
              v-model="verifs.picked[org]"
              class="urc_arg-title">
              {{ getOrgNameById(org) }}</el-checkbox>
          </div>
        </template>
        <template v-else>
          <p class="text-center">Верификаций, с которыми вы можете работать, не обнаружено.</p>
        </template>
      </div>

      <span slot="footer" class="dialog-footer buttons-wrap"
            v-if="verifs.win.length > 0 && (isSysAdmin || isOrgAdmin)">
        <el-button class="dialog-primary-btn" @click="saveVerifs">
          Сохранить</el-button>
        <el-button class="dialog-empty-btn" @click="winOn = false">
          Отмена</el-button>
      </span>

    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';

export default {

  props: {
    userId: null,
  },

  data() {
    return {
      winOn: false,
      userData: null,
      orgAdminOpened: '',
      verifs: {
        user: [],
        win: [],
        picked: {},
      },
    };
  },

  computed: {

    orgs() {
      return this.$store.getters['orgs/getOrgs'];
    },

    isOrgAdmin() {
      return this.$store.getters['user/isOrgAdmin'];
    },

    isSysAdmin() {
      return this.$store.getters['user/isSysAdmin'];
    },

    orgAdminOrgs() {
      return this.$store.getters['user/getWhereOrgAdmin'];
    },

  },

  methods: {

    saveVerifs() {
      const picked = [];
      Object.keys(this.verifs.picked).forEach((v) => {
        if (this.verifs.picked[v] === true) {
          picked.push(`org_${v}`);
        }
      });
      Vue.$loading.on();
      axios.put(`users/${this.userId}/verifications`, picked).then(() => {
        this.$message.success('Верификации сохранены.');
        this.winOn = false;
      }).catch(err => this.$notify.error(err.response.data.join(' ')))
        .finally(() => Vue.$loading.off());
    },

    openWin() {
      Vue.$loading.on();
      this.verifs.user = [];
      this.verifs.win = [];
      this.verifs.picked = {};
      axios.get(`users/${this.userId}`).then((r) => {
        this.userData = r.data;
        this.verifs.user = Object.keys(this.userData.Verifications)
          .filter(v => v.search(/^org_[\w-]+$/) > -1)
          .map(v => v.split('_')[1]);
        if (this.isSysAdmin) {
          this.verifs.win = this.orgs.map(o => o.OrganizationId);
        } else if (this.isOrgAdmin) {
          this.verifs.win = this.verifs.user.filter(
            uv => this.orgAdminOrgs.indexOf(uv) > -1);
        }
        this.verifs.win.forEach((wv) => {
          this.verifs.picked[wv] =
            Vue.set(this.verifs.picked, wv, this.verifs.user.indexOf(wv) > -1);
        });
        this.winOn = true;
      }).catch(err => this.$notify.error(err.response.data.join(' ')))
        .finally(() => Vue.$loading.off());
    },

    getOrgNameById(id) {
      const org = this.$store.getters['orgs/getOrgById'](id);
      return org ? org.ShortName : '';
    },

  },

};
</script>

<style lang="scss">
@import "../styles/common/main";

.user-verifications-control_uvc {
  .uvc_btn {
    width: 100%;
  }
  .uvc_win {
    .el-dialog {
      max-width: 800px;
    }
  }
  .uvc_cells {
    @include clearfix;
    margin: -5px;
    .uvc_cell {
      width: (100%/3);
      float: left;
      padding: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UserVerificationsControl.vue